import * as React from "react";
import { IconProps } from "./types";

export const ArrowUpLeftIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M17 17L7 7M7 7V17M7 7H17"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ArrowUpLeftIcon as React.FunctionComponent).displayName = "ArrowUpLeftIcon";

export default ArrowUpLeftIcon;
